// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#002339', // Azul oscuro (color primario)
      light: '#EFF0EC', // Color neutro
      dark: '#001924', // Azul aún más oscuro (para variación de sombras)
    },
    secondary: {
      main: '#00E875', // Verde (para elementos destacados)
      light: '#B0E8A1', // Verde claro (para resaltar elementos)
    },
    background: {
      default: '#F8F9FA', // Fondo principal claro
    },
    text: {
      primary: '#002339', // Azul oscuro para textos principales
      secondary: '#6B6B6B', // Gris oscuro para textos secundarios
      hint: '#B0B0B0', // Gris claro para sugerencias o textos menos relevantes
    },
    info: {
      main: '#6B6B6B', // Gris suave para detalles o información adicional
    },
    tableHeader: {
      main: '#f0f0f0', // Gris claro para el fondo del encabezado de la tabla
      text: '#4f4f4f', // Gris oscuro para el texto del encabezado
    },
  },
});

export default theme;
